import React from 'react';

import Layout from '../../components/Layout';
import Header from '../../components/Header';
import Navigation from '../../components/Navigation';
import { ActivitiesPageContent } from '../../components/Activities/ActivitiesPageContent';

const ActivitiesPage = () => {
  return (
    <Layout>
      <Layout.TopBar>
        <Header />
      </Layout.TopBar>
      <Layout.Body>
        <Layout.SideBar>
          <Navigation />
        </Layout.SideBar>
        <Layout.Content>
          <ActivitiesPageContent />
        </Layout.Content>
      </Layout.Body>
    </Layout>
  );
};

export default ActivitiesPage;
